// extracted by mini-css-extract-plugin
export default {"mainWrap":"MainPage_mainWrap__FU0eU","mainConBox":"MainPage_mainConBox__ObD1G","MainAniWrap":"MainPage_MainAniWrap__A1M35","logo":"MainPage_logo__FyKME"};